import styled from "styled-components";

export const LoadingWrapper = styled.div``;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;

  button:last-of-type {
    width: 9.75rem;
    height: 3rem;
    margin-left: auto;
    margin-right: 2rem;
    background-color: var(--white);
  }
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  row-gap: 1rem;
  column-gap: 2rem;
  margin-bottom: 0.7rem;

  width: 100%;

  input {
    width: 100%;
  }
`;

export const DocumentContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1.5fr 1fr;
  column-gap: 1rem;
  margin-bottom: 0;

  div {
    width: 100%;

    input {
      width: 100%;
    }
  }
`;
export const PasswordContainer = styled.div`
  display: flex;
  width: 100%;
  column-gap: 1rem;
  margin-bottom: 0;
`;

export const ViewPasswordButton = styled.button`
  width: 50px !important;
  background: none !important;
  height: 50px !important;
  margin-left: -47px !important;
  margin-top: 30px !important;
`;
